import { Link } from 'react-router-dom';
import { GoogleMap } from '../../components/map/map.jsx';
import { useMsal, } from '@azure/msal-react';
import { useState, useEffect } from "react";
import PropertyAPI from "../../api/property/property-api-factory";
import _ from "lodash";
import { googleMapsConfig } from '../../app';

export const PropertyMapPage = (props) => {
	
	const { instance, inProgress, accounts } = useMsal();
	const [data, setData] = useState([]);
	const [fetchComplete, setFetchComplete] = useState(false);
	const [fetchInProgress, setFetchInProgress] = useState(false);

	const api = new PropertyAPI(instance, inProgress, accounts, true);

	const mapConfig = {
		className: "h-100 w-100",
		style: { height: '100vh', width: '100%' },
		apiKey: googleMapsConfig.apiKey,
		center: {
			lat: 51.649082529711336,
			lng: -0.4014323585902774
		},
		zoom: 10
	};

    const fetchData = () => {
        if(!fetchInProgress){
            if (!fetchComplete) {
                setFetchInProgress(true);
                setFetchComplete(false);
                api.getTopN(100)
                    .then((data) => {
                        setData(data);
                        setFetchComplete(true);
                    }).catch(error => {
                        setData(null);
                        setFetchComplete(true);
                        setFetchInProgress(false);
                        console.log(error)
                    });
            }
        }
    };

	const throttledFetch = _.debounce(fetchData, 50, { leading: true, trailing: false, maxWait: 1000 });

	useEffect(() => {
		throttledFetch();
	});

	const getMarkers = () => {

		const markers = data && Array.isArray(data) && data.length > 0 ? data.filter(d => d && d.coordinates) : [];

		return markers.map((propertyDoc, i) => {

			return {
				name: propertyDoc.property.name,
				center: { lat: propertyDoc.coordinates.latitude, lng: propertyDoc.coordinates.longitude },
				navLink: `/property/detail/${propertyDoc.id}`,
				icon: 'fas fa-home',
				background: '#007bff'
			};
		});
	}

	return (
		<>
			<div className="position-absolute w-100 h-100 top-0 start-0 bottom-0 end-0">

				<GoogleMap {...mapConfig}
					markers={getMarkers()}>
				</GoogleMap>
			</div>

			<div className="app-content-padding position-relative">
				<ol className="breadcrumb">
					<li className="breadcrumb-item"><Link to="/dashboard/v3" className="text-white">Home</Link></li>
					<li className="breadcrumb-item active text-white">Map</li>
				</ol>
				{/* <h1 className="page-header text-white">Google Map <small className="text-white-transparent-5">header small text goes here...</small></h1> */}
			</div>
		</>
	);
}


export default PropertyMapPage;